import script from "./ListingPageDescriptionPodcast.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListingPageDescriptionPodcast.vue?vue&type=script&setup=true&lang=ts"

import "./ListingPageDescriptionPodcast.vue?vue&type=style&index=0&id=4cbae343&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cbae343"]])

export default __exports__